<template>
  <div class="search-claim-container">
    <a-modal
      title="确认筛选列"
      :width="1200"
      :bodyStyle="bodyStyle"
      v-model="columnsVisible"
      @ok="hideColumnsModal"
      okText="确认"
      cancelText="取消"
    >
      <div class="chuansuo common-horizontal-around-flex">
        <a-transfer
          style="height:300px;"
          :dataSource="mockData"
          :titles="['Source', 'Target']"
          :targetKeys="targetKeys"
          :selectedKeys="selectedKeys"
          @change="handleChange"
          @selectChange="handleSelectChange"
          :render="item=>item.title"
          :disabled="disabled"
        />
      </div>
    </a-modal>
    <bread-slice basePath="/claim" :routes="routes"></bread-slice>
    <div class="claim-basic-info">
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>索赔单号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.applicationNumber"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <!-- <div class="w-30 text-right">
            <span>索赔单提交地点：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.submitLocation"></a-input>
          </div>-->

          <div class="w-30 text-right">
            <span>车主姓名：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.customerName"></a-input>
          </div>
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>DMS索赔单号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.dmsClaimNumber"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>索赔单状态：</span>
          </div>
          <div class="w-70">
            <a-select style="width:100%;" @change="handleClaimStatusChange">
              <a-select-option value>全部</a-select-option>
              <a-select-option value="0">草稿</a-select-option>
              <a-select-option value="1">待批准</a-select-option>
              <a-select-option value="2">需更正</a-select-option>
              <a-select-option value="3">已批准</a-select-option>
              <a-select-option value="4">已拒单</a-select-option>
              <a-select-option value="5">已赔付</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>DMS工单号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.workOrderNumber"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>索赔类型：</span>
          </div>
          <div class="w-70">
            <a-select style="width:100%;" @change="handleChangeClaimType">
              <a-select-option value>请选择</a-select-option>
              <a-select-option v-for="option in claimTypeList" :key="option.id">{{ option.name }}</a-select-option>
            </a-select>
          </div>
          <!-- <div class="w-30 text-right">
            <span>审计状态：</span>
          </div>
          <div class="w-70">
            <a-select defaultValue="lucy" style="width:100%;" @change="handleChange">
              <a-select-option value="jack">活动/召回</a-select-option>
              <a-select-option value="lucy">车辆保修</a-select-option>
              <a-select-option value="Yiminghe">预授权</a-select-option>
              <a-select-option value="Yiminghe1">善意索赔</a-select-option>
              <a-select-option value="Yiminghe2">配件保修</a-select-option>
              <a-select-option value="Yiminghe3">延长保修</a-select-option>
            </a-select>
          </div>-->
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>车型代码：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.vehicleModelCode"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>创建日期：</span>
          </div>
          <div class="w-70 c-h-b-flex">
            <!-- <a-date-picker class="w-100" @change="handleClaimCreateDateChange" /> -->
            <a-range-picker class="w-100" @change="handleClaimCreateDateChange" />
            <!-- <a-date-picker
              class="w-45"
              :value="searchClaimObj.createStartDate"
              @change="startCreateDateChange"
            />
            <span>至</span>
            <a-date-picker
              class="w-45"
              :value="searchClaimObj.createEndDate"
              @change="endCreateDateChange"
            /> -->
          </div>
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>车架号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.vehicleVin"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>批准日期：</span>
          </div>
          <div class="w-70 c-h-b-flex">
            <a-range-picker class="w-100" @change="handleApproveDateChange" />
            <!-- <a-date-picker
              class="w-45"
              :value="searchClaimObj.approveStartDate"
              @change="startApproveDateChange"
            />
            <span>至</span>
            <a-date-picker
              class="w-45"
              :value="searchClaimObj.approveEndDate"
              @change="endApproveDateChange"
            /> -->
          </div>
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>主要故障件号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.causalPartCode"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>支付日期：</span>
          </div>
          <div class="w-70 c-h-b-flex">
            <a-range-picker class="w-100" @change="handlePayDateChange" />
            <!-- <a-date-picker
              class="w-45"
              :value="searchClaimObj.payStartDate"
              @change="startPayDateChange"
            />
            <span>至</span>
            <a-date-picker
              class="w-45"
              :value="searchClaimObj.payEndDate"
              @change="endPayDateChange"
            /> -->
          </div>
        </div>
      </div>
      <div class="h-40 common-horizontal-around-flex">
        <div class="w-50 common-horizontal-around-flex">
          <div class="w-30 text-right">
            <span>保修范围/活动代码：</span>
          </div>
          <div class="w-70">
            <a-input v-model="searchClaimObj.warrantyOrActivity"></a-input>
          </div>
        </div>
        <div class="w-50 common-horizontal-around-flex"></div>
      </div>
      <div class="common-horizontal-around-flex m-top-20 flex-end">
        <div class="c-h-b-flex t-w-150 flex-end">
          <a-button class="m-right-10" @click="reloadPage">重 置</a-button>
          <a-button type="primary" @click="searchClaim">查 询</a-button>
        </div>
      </div>

      <div class="common-horizontal-around-flex m-top-20" style="justify-content:flex-start;">
        <!-- <a-button type="primary" @click="showColumnsModal">确认筛选列</a-button> -->
        <a-button type="primary" :loading="exportClaimLoading" @click="exportButton">导出</a-button>
      </div>
      <div class="table-container m-top-20"></div>
    </div>
    <div class="claim-basic-info" id="table-container">
      <div
        class="common-horizontal-around-flex"
        style="text-align:center;margin:0 auto; overflow:scroll"
        :style="claimTableStyle"
      >
        <a-table
          style="width:100%;"
          :loading="searchClaimTableLoading"
          :scroll="tableScroll"
          :columns="columns"
          :dataSource="claimList"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="record">
            <a
              @click="handleClaimNumberClick(record.id)"
              style="font-weight:bold;text-decoration:underline"
            >{{record.applicationNumber}}</a>
          </span>
          <template slot="createDate" slot-scope="createDate">{{createDate}}</template>
          <template slot="approveDate" slot-scope="approveDate">{{approveDate}}</template>
          <template slot="payDate" slot-scope="payDate">{{payDate}}</template>
        </a-table>
      </div>
      <div class="pagination-container"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import breadSlice from "../../components/breadSlice.vue";
import {
  table,
  DatePicker,
  Select,
  Transfer,
  Modal,
  Input,
  Button,
  message,
} from "ant-design-vue";
import Vue from "vue";
Vue.use(table);
Vue.use(DatePicker);
Vue.use(Select);
Vue.use(Transfer);
Vue.use(Modal);
Vue.use(Input);
Vue.use(Button);
Vue.use(message);
export default {
  data() {
    return {
      applicationNumber: "", //索赔单号
      dmsClaimNumber: "", //DMS索赔单号
      workOrderNumber: "", // 工单号
      vehicleVin: "", //车型代码
      vehicleModelCode: "", //车架号
      causalPartCode: "", // 主要故障件号
      warrantyOrActivity: "", // 保修范围/活动代码
      submitLocation: "", // 索赔单提交地点
      status: "", // 索赔单状态
      auditStatus: "", // 审计状态
      createStartDate: "", //创建日期起
      createEndDate: "", //创建日期止
      approveStartDate: "", //批准日期起
      approveEndDate: "", //批准日期止
      payStartDate: "", //支付日期起
      payEndDate: "", //支付日期止
      customerName: "", //车主姓名

      tableScroll: {
        x: 3000,
        y: false,
      },
      columns: [],
      targetKeys: [],
      mockData: [],
      selectedKeys: [],
      bodyStyle: {},
      columnsVisible: false,
      disabled: false,
      routes: [
        {
          path: "/search",
          breadcrumbName: "索赔",
        },
        {
          path: "/claim/search",
          breadcrumbName: "查询索赔单",
        },
      ],
      tableWidth: "500px",
      claimTableStyle: {
        width: this.tableWidth,
      },
    };
  },
  mounted() {
    this.searchClaimObj.preClaimType = "";
    this.searchClaimObj.claimTypeDictId = "";
    this.searchClaimObj.applicationNumber = "";
    this.searchClaimObj.submitLocation = "";
    this.searchClaimObj.dmsClaimNumber = "";
    this.searchClaimObj.workOrderNumber = "";
    this.searchClaimObj.vehicleModelCode = "";
    this.searchClaimObj.vehicleVin = "";
    this.searchClaimObj.causalPartCode = "";
    this.searchClaimObj.warrantyOrActivity = "";
    this.searchClaimObj.customerName = "";
    this.searchClaimObj.status = "";
    this.searchClaimObj.createStartDate = "";
    this.searchClaimObj.createEndDate = "";
    this.searchClaimObj.approveStartDate = "";
    this.searchClaimObj.approveEndDate = "";
    this.searchClaimObj.payStartDate = "";
    this.searchClaimObj.payEndDate = "";
    let params = ["claimSearchDateType", "claimStatus", "claimType"];
    this.$store.dispatch("getDictType", params.join(","));
    this.generageMockData();
    this.columns = this.searchColumns;
    if (
      this.$route.query.applicationNumber ||
      this.$route.query.workOrderNumber ||
      this.$route.query.vehicleVin ||
      this.$route.query.dmsClaimNumber
    ) {
      this.searchClaimObj.applicationNumber = this.$route.query.applicationNumber;
      this.searchClaimObj.workOrderNumber = this.$route.query.workOrderNumber;
      this.searchClaimObj.vehicleVin = this.$route.query.vehicleVin;
      this.searchClaimObj.dmsClaimNumber = this.$route.query.dmsClaimNumber;
      this.$store.dispatch("searchClaim", this.searchClaimObj);
    } else {
      this.$store.dispatch("searchClaim", {});
    }
  },
  created() {
    // var doss = document.getElementById("table-container");
    // console.log(doss.offsetWidth);
    // this.tableWidth = doss.offsetWidth;
  },
  methods: {
    handleChangeClaimType: function (value) {
      this.searchClaimObj.claimTypeDictId = value;
      console.log(`selected ${value}`);
    },
    exportButton: function () {
      message.success("列表正在导出");
      this.$store.dispatch("exportClaim", this.searchClaimObj);
    },
    reloadPage: function () {
      window.location.reload();
    },
    handlePayDateChange: function(date, dateString) {
      Object.assign(this.searchClaimObj, { payStartDate: dateString[0] });
      Object.assign(this.searchClaimObj, { payEndDate: dateString[1] });
    },
    // 支付日期
    // startPayDateChange: function (date, dateString) {
    //   this.searchClaimObj.payStartDate = dateString;
    // },
    // endPayDateChange: function (date, dateString) {
    //   this.searchClaimObj.payEndDate = dateString;
    // },
    handleApproveDateChange: function(date, dateString) {
      Object.assign(this.searchClaimObj, { approveStartDate: dateString[0] });
      Object.assign(this.searchClaimObj, { approveEndDate: dateString[1] });
    },
    // 批准日期
    startApproveDateChange: function (date, dateString) {
      this.searchClaimObj.approveStartDate = dateString;
    },
    endApproveDateChange: function (date, dateString) {
      this.searchClaimObj.approveEndDate = dateString;
    },
    handleClaimCreateDateChange: function(date, dateString) {
      Object.assign(this.searchClaimObj, { createStartDate: dateString[0] });
      Object.assign(this.searchClaimObj, { createEndDate: dateString[1] });
    },
    // 创建日期
    // startCreateDateChange: function (date, dateString) {
    //   this.searchClaimObj.createStartDate = dateString;
    // },
    // endCreateDateChange: function (date, dateString) {
    //   this.searchClaimObj.createEndDate = dateString;
    // },
    handleClaimStatusChange: function (value) {
      console.log(value);
      this.searchClaimObj.status = value;
    },
    searchClaim: function () {
      this.$store.dispatch("searchClaim", this.searchClaimObj);
    },
    handleClaimDateChange: function (value) {
      value;
    },
    handleTableChange: function (pagination, filters, sorter) {
      let p = {
        current: pagination.current,
        size: pagination.pageSize,
        column: sorter.columnKey,
        ...this.searchClaimObj,
      };
      if (sorter.order == "ascend") {
        Object.assign(p, { asc: true });
        this.$store.dispatch("searchClaim", p);
      } else if (sorter.order == "descend") {
        Object.assign(p, { asc: false });
        this.$store.dispatch("searchClaim", p);
      } else {
        this.$store.dispatch("searchClaim", p);
      }
      filters;
      sorter;
    },
    handleClaimNumberClick: function (item) {
      console.log(item);
      window.open("#/claim/detail/" + item);
    },
    generageMockData: function () {
      console.log(this.columns.length);
      console.log(this.searchClaimObjNames.length);
      for (let i = 0; i < this.searchClaimObjNames.length; i++) {
        this.mockData.push({
          key: i.toString(),
          title: this.searchClaimObjNames[i],
          description: `description of content ${i}`,
          disabled: false,
        });
      }
      // this.targetKeys = this.mockData
      //   .filter(item => item.key % 2 === 0)
      //   .map(item => item.key);
    },
    pageChange: function () {},
    pageSizeChange: function () {},
    hideColumnsModal: function () {
      this.columnsVisible = false;
    },
    showColumnsModal: function () {
      this.columnsVisible = true;
    },
    handleChange(nextTargetKeys, direction, moveKeys) {
      this.targetKeys = nextTargetKeys;

      console.log("targetKeys: ", nextTargetKeys);
      // console.log("direction: ", direction);
      // console.log("moveKeys: ", moveKeys);
      direction;
      moveKeys;

      // let tt = this.searchClaimObjNames.filter((item, index) => {});
      let arr = [];
      nextTargetKeys.map((item) => {
        console.log(item);
        arr.push(this.searchClaimObjNames[item]);
        // lasttime:
      });
      console.log(arr);
      let tempColumns = [];
      this.columns.map((item) => {
        if (arr.indexOf(item.title) > -1) {
          tempColumns.push(item);
        }
      });
      console.log(tempColumns);
      this.columns = tempColumns;
      Object.assign(this.tableScroll, {
        x: this.columns.length * 100,
      });
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];

      // console.log("sourceSelectedKeys: ", sourceSelectedKeys);
      // console.log("targetSelectedKeys: ", targetSelectedKeys);
      sourceSelectedKeys;
      targetSelectedKeys;
    },
    handleScroll(direction, e) {
      console.log("direction:", direction);
      console.log("target:", e.target);
    },
    handleDisable(disabled) {
      this.disabled = disabled;
    },
  },
  watch: {
    $route(val) {
      if (val) {
        this.searchClaimObj.applicationNumber = this.$route.query.applicationNumber;
        this.searchClaimObj.workOrderNumber = this.$route.query.workOrderNumber;
        this.searchClaimObj.vehicleVin = this.$route.query.vehicleVin;
        this.searchClaimObj.dmsClaimNumber = this.$route.query.dmsClaimNumber;
        this.$store.dispatch("searchClaim", this.searchClaimObj);
      }
    },
    claimList: function (val) {
      if (val) {
        this.pagination.total = this.claimListCount;
      }
    },
  },
  computed: {
    ...mapGetters([
      "claimSearchDateTypeList",
      "claimStatusList",
      "claimTypeList",
    ]),
    ...mapState({
      pagination: (state) => state.claim.searchClaimPagination,
      searchColumns: (state) => state.claim.columns,
      claimList: (state) => state.claim.claimList,
      claimListCount: (state) => state.claim.claimListCount,
      searchClaimObj: (state) => state.claim.searchClaimObj,
      searchClaimObjNames: (state) => state.claim.searchClaimObjNames,
      exportClaimLoading: state => state.claim.exportClaimLoading,
      searchClaimTableLoading: state => state.claim.searchClaimTableLoading,
    }),
  },
  components: { breadSlice },
};
</script>

<style lang='less'>
@import "../../../public/less/claim/searchClaim.less";
</style>
